import BaseComponent from '../../js/base-component';

export default class WhoisComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.content = this.refs.content;

    }

    static getRequiredRefs(){
        return ['content'];
    }

    init(){
        this.loadData();
    }

    async loadData(){

        const whoisPage = this.content.getAttribute('id') === 'load_whois';

        const response = await fetch(window.location.pathname, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: whoisPage ? url_lang_prefix + '/whois' + review_record_ip + '&ajax=1' : `ajax=1&action=get_as_whois&record=${record_as}`,
        });

        const apiData = await response.json();

        if(apiData.error){
            document.getElementById('whois_descr_first_line').textContent = 'No info found';
            this.content.classList.add('hidden');
            console.log(e);
            return;
        }

        const isWhoisPage = document.getElementById('whois_descr_first_line');
        if (isWhoisPage) {
            const descrMatch = apiData.data.match(/descr:\s+(.*)/);
            const firstDescrLine = descrMatch ? descrMatch[1] : 'Whois information';
            isWhoisPage.textContent = firstDescrLine;
        }
        this.content.innerHTML = `<pre>${apiData.data}</pre>`;
    }

    onDestroy(){
    }
}
